import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-my-result',
  templateUrl: './my-result.component.html',
  styleUrls: ['./my-result.component.scss']
})
export class MyResultComponent implements OnInit {

  constructor() { }

  @Input() number: number = 0;

  ngOnInit(): void {
  }

}
